// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__FM173","add":"style_add__lEGvP","actions":"style_actions__QMobC","actions_btn":"style_actions_btn__63aIw"};